export const validName = (name?: string | null): boolean => {
  return name !== "-" && !!name;
};

export function formatFirstName(name: string): string {
  return name
    .toLocaleLowerCase("fr-FR")
    .replace(
      /(^|[\s\-'’])(\p{L})/gu,
      (_match, separator: string, letter: string) =>
        `${separator}${letter.toLocaleUpperCase("fr-FR")}`,
    );
}
